const getFullPrice = ({ meal, noRooms = 1, starRating = null, fees = {} }) => {
  const price = getPrice({ meal, noRooms, starRating, fees }) + meal.discount
  return Math.ceil(price * 100) / 100
}

const getServiceFee = ({ meal, noRooms = 1, starRating = null, fees = {} }) => {
  const stars = starRating || 0
  const fee = (fees && fees[stars]) ? fees[stars] : { percent: 0, value: 0 }
  const percent = parseFloat(fee.percent) || 0
  const value = parseFloat(fee.value) || 0
  const retVal = Math.ceil((meal.price + meal.tax) * percent / 100 + (value * noRooms))
  return Math.ceil(retVal * 100) / 100
}

const getPrice = ({ meal, noRooms = 1, starRating = null, fees = {} }) => {
  const price = meal.price + meal.tax + getServiceFee({ meal, noRooms, starRating, fees })
  return Math.ceil(price * 100) / 100
}

const hotelRatings = [1, 2, 3, 4, 5]

export {
  getServiceFee,
  getPrice,
  getFullPrice,
  hotelRatings
}
